module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/OrangeTimer/images/expiration-time-icon.3bd8febf.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/OrangeTimer/images/expiration-time-icon.png
// module id = 2941
// module chunks = 11